 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~d0ae3f07": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~d0ae3f07": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"3d~ad0e187f":"3d~ad0e187f","3d~18c12a44":"3d~18c12a44","assets~ebe4e41b":"assets~ebe4e41b","blizzard~253ae210":"blizzard~253ae210","fast-text-encoding~7274e1de":"fast-text-encoding~7274e1de","fetch~2a85e171":"fetch~2a85e171","intersection-observer~43ec74bd":"intersection-observer~43ec74bd","localization10~7cd30993":"localization10~7cd30993","localization12~a18c86ca":"localization12~a18c86ca","localization14~5732169e":"localization14~5732169e","localization16~8d4fd990":"localization16~8d4fd990","localization18~7e7b3a3c":"localization18~7e7b3a3c","localization20~169bc31f":"localization20~169bc31f","localization22~ad04a6a9":"localization22~ad04a6a9","localization24~b0f21617":"localization24~b0f21617","localization26~dcf8dfcd":"localization26~dcf8dfcd","localization28~011ef976":"localization28~011ef976","localization30~4f586233":"localization30~4f586233","localization32~5d83d45d":"localization32~5d83d45d","localization34~0be6b969":"localization34~0be6b969","localization36~a38c41dc":"localization36~a38c41dc","localization38~9e5ada23":"localization38~9e5ada23","localization40~dba7594c":"localization40~dba7594c","localization42~5d492a36":"localization42~5d492a36","localization44~57589d6c":"localization44~57589d6c","localization46~433a1b50":"localization46~433a1b50","localization48~8eedbe33":"localization48~8eedbe33","localization50~6b9efad8":"localization50~6b9efad8","localization52~dcdb86c7":"localization52~dcdb86c7","localization54~28d55a83":"localization54~28d55a83","localization56~9f7127c5":"localization56~9f7127c5","localization58~9e4eb2da":"localization58~9e4eb2da","localization60~4843b4cb":"localization60~4843b4cb","localization62~085d2ade":"localization62~085d2ade","localization64~eb863411":"localization64~eb863411","localization66~2617e5ab":"localization66~2617e5ab","localization68~339b897b":"localization68~339b897b","localization70~1af602de":"localization70~1af602de","localization72~9b04e63d":"localization72~9b04e63d","localization74~75467d11":"localization74~75467d11","localization76~697db585":"localization76~697db585","localization78~3bae3201":"localization78~3bae3201","localization80~dbf4bc29":"localization80~dbf4bc29","localization82~69362d54":"localization82~69362d54","localization84~df501700":"localization84~df501700","localization86~7ad37ff8":"localization86~7ad37ff8","localization88~9031a70d":"localization88~9031a70d","localization90~93c13ac0":"localization90~93c13ac0","sentry-tracing~45e1e377":"sentry-tracing~45e1e377"}[chunkId]||chunkId) + "-legacy." + {"3d~ad0e187f":"1a052f64","3d~18c12a44":"e76a2ff4","assets~ebe4e41b":"02917a79","blizzard~253ae210":"0664f12f","chunk-2d213958":"ca0ccbcf","fast-text-encoding~7274e1de":"2bd12c65","fetch~2a85e171":"ee38d6b6","intersection-observer~43ec74bd":"78e9ac00","localization10~7cd30993":"dc8b0999","localization12~a18c86ca":"433bd472","localization14~5732169e":"c18591a5","localization16~8d4fd990":"a6e85b21","localization18~7e7b3a3c":"d2584c42","localization20~169bc31f":"3124aa10","localization22~ad04a6a9":"c2e22232","localization24~b0f21617":"c610dbb6","localization26~dcf8dfcd":"6047986d","localization28~011ef976":"38078fa0","localization30~4f586233":"78aba8ee","localization32~5d83d45d":"dee9972d","localization34~0be6b969":"43cc48e3","localization36~a38c41dc":"bc8a005f","localization38~9e5ada23":"bbb33c6c","localization40~dba7594c":"3d3215fe","localization42~5d492a36":"60c294f6","localization44~57589d6c":"b631b455","localization46~433a1b50":"d132016e","localization48~8eedbe33":"0d01213d","localization50~6b9efad8":"51efc8a2","localization52~dcdb86c7":"49bfb769","localization54~28d55a83":"d1417578","localization56~9f7127c5":"9eded346","localization58~9e4eb2da":"a7e2227d","localization60~4843b4cb":"4651c07a","localization62~085d2ade":"43ea83ae","localization64~eb863411":"4b5cb9f2","localization66~2617e5ab":"82955bd2","localization68~339b897b":"6e038ce4","localization70~1af602de":"15b4ee16","localization72~9b04e63d":"73583323","localization74~75467d11":"74507235","localization76~697db585":"a84cfa0d","localization78~3bae3201":"b7791aec","localization80~dbf4bc29":"224bdab2","localization82~69362d54":"c49fc8d2","localization84~df501700":"a38b4cd7","localization86~7ad37ff8":"9b6b3bf3","localization88~9031a70d":"86bff222","localization90~93c13ac0":"eb703d2f","sentry-tracing~45e1e377":"d5230f97"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3d~18c12a44":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"3d~ad0e187f":"3d~ad0e187f","3d~18c12a44":"3d~18c12a44","assets~ebe4e41b":"assets~ebe4e41b","blizzard~253ae210":"blizzard~253ae210","fast-text-encoding~7274e1de":"fast-text-encoding~7274e1de","fetch~2a85e171":"fetch~2a85e171","intersection-observer~43ec74bd":"intersection-observer~43ec74bd","localization10~7cd30993":"localization10~7cd30993","localization12~a18c86ca":"localization12~a18c86ca","localization14~5732169e":"localization14~5732169e","localization16~8d4fd990":"localization16~8d4fd990","localization18~7e7b3a3c":"localization18~7e7b3a3c","localization20~169bc31f":"localization20~169bc31f","localization22~ad04a6a9":"localization22~ad04a6a9","localization24~b0f21617":"localization24~b0f21617","localization26~dcf8dfcd":"localization26~dcf8dfcd","localization28~011ef976":"localization28~011ef976","localization30~4f586233":"localization30~4f586233","localization32~5d83d45d":"localization32~5d83d45d","localization34~0be6b969":"localization34~0be6b969","localization36~a38c41dc":"localization36~a38c41dc","localization38~9e5ada23":"localization38~9e5ada23","localization40~dba7594c":"localization40~dba7594c","localization42~5d492a36":"localization42~5d492a36","localization44~57589d6c":"localization44~57589d6c","localization46~433a1b50":"localization46~433a1b50","localization48~8eedbe33":"localization48~8eedbe33","localization50~6b9efad8":"localization50~6b9efad8","localization52~dcdb86c7":"localization52~dcdb86c7","localization54~28d55a83":"localization54~28d55a83","localization56~9f7127c5":"localization56~9f7127c5","localization58~9e4eb2da":"localization58~9e4eb2da","localization60~4843b4cb":"localization60~4843b4cb","localization62~085d2ade":"localization62~085d2ade","localization64~eb863411":"localization64~eb863411","localization66~2617e5ab":"localization66~2617e5ab","localization68~339b897b":"localization68~339b897b","localization70~1af602de":"localization70~1af602de","localization72~9b04e63d":"localization72~9b04e63d","localization74~75467d11":"localization74~75467d11","localization76~697db585":"localization76~697db585","localization78~3bae3201":"localization78~3bae3201","localization80~dbf4bc29":"localization80~dbf4bc29","localization82~69362d54":"localization82~69362d54","localization84~df501700":"localization84~df501700","localization86~7ad37ff8":"localization86~7ad37ff8","localization88~9031a70d":"localization88~9031a70d","localization90~93c13ac0":"localization90~93c13ac0","sentry-tracing~45e1e377":"sentry-tracing~45e1e377"}[chunkId]||chunkId) + "." + {"3d~ad0e187f":"31d6cfe0","3d~18c12a44":"51ff64c8","assets~ebe4e41b":"31d6cfe0","blizzard~253ae210":"31d6cfe0","chunk-2d213958":"31d6cfe0","fast-text-encoding~7274e1de":"31d6cfe0","fetch~2a85e171":"31d6cfe0","intersection-observer~43ec74bd":"31d6cfe0","localization10~7cd30993":"31d6cfe0","localization12~a18c86ca":"31d6cfe0","localization14~5732169e":"31d6cfe0","localization16~8d4fd990":"31d6cfe0","localization18~7e7b3a3c":"31d6cfe0","localization20~169bc31f":"31d6cfe0","localization22~ad04a6a9":"31d6cfe0","localization24~b0f21617":"31d6cfe0","localization26~dcf8dfcd":"31d6cfe0","localization28~011ef976":"31d6cfe0","localization30~4f586233":"31d6cfe0","localization32~5d83d45d":"31d6cfe0","localization34~0be6b969":"31d6cfe0","localization36~a38c41dc":"31d6cfe0","localization38~9e5ada23":"31d6cfe0","localization40~dba7594c":"31d6cfe0","localization42~5d492a36":"31d6cfe0","localization44~57589d6c":"31d6cfe0","localization46~433a1b50":"31d6cfe0","localization48~8eedbe33":"31d6cfe0","localization50~6b9efad8":"31d6cfe0","localization52~dcdb86c7":"31d6cfe0","localization54~28d55a83":"31d6cfe0","localization56~9f7127c5":"31d6cfe0","localization58~9e4eb2da":"31d6cfe0","localization60~4843b4cb":"31d6cfe0","localization62~085d2ade":"31d6cfe0","localization64~eb863411":"31d6cfe0","localization66~2617e5ab":"31d6cfe0","localization68~339b897b":"31d6cfe0","localization70~1af602de":"31d6cfe0","localization72~9b04e63d":"31d6cfe0","localization74~75467d11":"31d6cfe0","localization76~697db585":"31d6cfe0","localization78~3bae3201":"31d6cfe0","localization80~dbf4bc29":"31d6cfe0","localization82~69362d54":"31d6cfe0","localization84~df501700":"31d6cfe0","localization86~7ad37ff8":"31d6cfe0","localization88~9031a70d":"31d6cfe0","localization90~93c13ac0":"31d6cfe0","sentry-tracing~45e1e377":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/web-builder/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~0f485567","chunk-vendors~7274e1de"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
